<template>
    <div class="cart-item">
        <slot v-bind="this"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            data: Object
        },
        computed: {
            price() { return this.data.price },
            total() { return this.data.total }
        },
    }
</script>